// Keep the centre opaque, with feathering confined to the sloping light edges.
export default function BookRevealBeam() {
	return (
		<>
		<div className="book-reveal-light" aria-hidden="true">
			<svg className="book-reveal-beam" viewBox="0 0 1000 1000" preserveAspectRatio="none" focusable="false">
				<defs>
					<filter id="book-beam-glow" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="18" /></filter>
					<filter id="book-beam-edge" x="-10%" y="-10%" width="120%" height="120%"><feGaussianBlur stdDeviation="3" /></filter>
				</defs>
				<g className="book-reveal-beam-desktop">
					<polygon points="1000,0 740,1000 0,1000 0,220" className="book-reveal-beam-glow" />
					<polygon points="1000,0 740,1000 0,1000 0,220" className="book-reveal-beam-core" />
				</g>
				<g className="book-reveal-beam-mobile">
					<polygon points="1000,0 1300,1000 0,1000 0,120" className="book-reveal-beam-glow" />
					<polygon points="1000,0 1300,1000 0,1000 0,120" className="book-reveal-beam-core" />
				</g>
			</svg>
		</div>
		<svg className="book-reveal-torch" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
			<defs><linearGradient id="book-torch-metal" x1="0" x2="1"><stop stopColor="#253b32" /><stop offset=".45" stopColor="#5f7569" /><stop offset="1" stopColor="#18291f" /></linearGradient></defs>
			<g transform="translate(50 50) rotate(45)">
				<rect x="-11" y="-56" width="22" height="42" rx="5" fill="url(#book-torch-metal)" />
				<path d="M-10-43H10M-10-37H10M-10-31H10" stroke="#95a89b" strokeWidth="2" opacity=".6" />
				<path d="M-11-17L-18 2H18L11-17Z" fill="url(#book-torch-metal)" stroke="#8da494" />
				<ellipse cy="3" rx="18" ry="6" fill="#b5c4b9" stroke="#243c2b" />
				<ellipse cy="4" rx="13" ry="3.5" fill="#fff4c0" />
			</g>
		</svg>
		</>
	);
}
